/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of person
 * @export
 */
export const PersonTypeEnum = {
    /**
    * All types
    */
    All: 0,
    /**
    * Individual person
    */
    NaturalPerson: 1,
    /**
    * Legal entity
    */
    LegalEntity: 2
} as const;
export type PersonTypeEnum = typeof PersonTypeEnum[keyof typeof PersonTypeEnum];


export function instanceOfPersonTypeEnum(value: any): boolean {
    for (const key in PersonTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(PersonTypeEnum, key)) {
            if (PersonTypeEnum[key as keyof typeof PersonTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PersonTypeEnumFromJSON(json: any): PersonTypeEnum {
    return PersonTypeEnumFromJSONTyped(json, false);
}

export function PersonTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonTypeEnum {
    return json as PersonTypeEnum;
}

export function PersonTypeEnumToJSON(value?: PersonTypeEnum | null): any {
    return value as any;
}

export function PersonTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): PersonTypeEnum {
    return value as PersonTypeEnum;
}

